// export const BASEURL = process.env.REACT_APP_BASEURL!
// export const APP_URL = process.env.REACT_APP_URL!
// export const STAFF_BASEURL = process.env.REACT_APP_STAFF_BASEURL!
// export const APP_ID = process.env.REACT_APPID!
// export const ENV = process.env.NODE_ENV!
export const BASEURL =  'https://admissionsvr.etechnosoft.org'
export const APP_URL = process.env.REACT_APP_URL!
export const STAFF_BASEURL =  'https://opm.etechnosoft.org'
export const APP_ID ='5d16710c6623a14317ba97d723802b80'
export const ENV = process.env.NODE_ENV!